/* eslint-disable */
export default {
  doNotCall: '谢绝来电',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
